import req from "@/utils/request";
export const details = (params) => req.post("/site-service/m/push/details", params);